export default __webpack_public_path__ + "static/media/nineatoms.7bbb85d0.svg";